var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.333h512V426.67H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M223.397 255.996c.273-.304.543-.609.813-.916-.27.308-.546.61-.82.916h.007zm-34.18 41.927l10.958 22.913 24.747-5.718-11.083 22.853 19.9 15.781-24.776 5.585.069 25.398-19.815-15.89-19.814 15.89.069-25.398-24.776-5.585 19.9-15.781-11.083-22.853 24.746 5.718zm197.859 28.464l5.227 10.929 11.803-2.728-5.286 10.9 9.492 7.528-11.818 2.663.032 12.114-9.45-7.578-9.45 7.578.032-12.114-11.817-2.663 9.491-7.528-5.285-10.9 11.803 2.728zm-48.623-115.939l5.227 10.93 11.803-2.729-5.286 10.901 9.491 7.528-11.817 2.663.032 12.115-9.45-7.58-9.451 7.58.033-12.115-11.818-2.663 9.491-7.528-5.284-10.901 11.802 2.729zm48.623-66.25l5.227 10.93 11.803-2.73-5.286 10.902 9.491 7.527-11.817 2.664.032 12.114-9.45-7.58-9.45 7.58.032-12.114-11.817-2.664 9.491-7.527-5.285-10.902 11.803 2.73zm42.471 49.688l5.227 10.929 11.802-2.728-5.284 10.9 9.491 7.527-11.818 2.664.033 12.114-9.451-7.578-9.45 7.578.032-12.114-11.817-2.664 9.491-7.527-5.286-10.9 11.803 2.728zm-30.368 57.97l4.11 12.652h13.304l-10.763 7.82 4.112 12.652-10.763-7.819-10.765 7.819 4.112-12.652-10.763-7.82h13.304z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.553l45.167-25.099H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.827V85.333h55.652v48.573l87.43-48.573z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
  fill: "#d80027"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
  fill: "#d80027"
})));

export default SvgAu;